import type {ReactElement} from 'react';
import React, {useEffect, useRef, useState} from 'react';
import type {TextSlideListItem} from '@Components/contextual-menu/components/slideshow-list-item/slideshow-list-item.types';
import {SlideShowItemType} from '@Components/contextual-menu/components/slideshow-list-item/slideshow-list-item.types';
import {SlideshowListItem} from '@Components/contextual-menu/components/slideshow-list-item';
import {InputField} from '@Components/input-field-v2';
import {InputFieldSize} from '@Components/input-field-v2/input-field.types';

export function TextSlideItem({className = '', isSelected = false, ...props}: Omit<TextSlideListItem, 'type'>): ReactElement<any> {
  const ref = useRef<HTMLTextAreaElement>(null);
  const [numberOfRows, setNumberOfRows] = useState(1);

  const focusTextSlide = (id: string): void => {
    if (props.id === id && ref && ref.current) {
      ref.current.focus();
    }
  };

  window.posterEditor?.whiteboard?.on('textSlide:added', focusTextSlide);

  useEffect(() => {
    const rows = props.input.split('\n').length;
    if (rows !== numberOfRows && rows <= 3) {
      setNumberOfRows(rows);
    }
  }, [props.input]);

  const getInputField = (): ReactElement<any> => {
    return (
      <InputField
        isMultiline
        // @ts-ignore
        ref={ref}
        maxNumberOfRows={numberOfRows}
        placeholder={window.i18next.t('pmwjs_some_text')}
        onInputChange={(val: string): void => {
          props.onInputChange(val, props.id);
        }}
        onInputChangeEnded={(val: string): void => {
          props.onInputChangeEnded(val, props.id);
        }}
        elementTitle={window.i18next.t('pmwjs_add_your_text')}
        input={props.input}
        size={InputFieldSize.SMALL}
        hasIcon="icon-text"
      />
    );
  };

  return (
    <SlideshowListItem
      type={SlideShowItemType.TEXT}
      onClick={(id: string): void => {
        props.onClick(id);
      }}
      onDelete={(id: string): void => {
        props.onDelete(id);
      }}
      element={getInputField()}
      id={props.id}
      index={props.index}
      className={className}
      isSelected={isSelected}
      duration={props.duration}
    />
  );
}
